
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import useTranslation from "next-translate/useTranslation";
import Router from "next/router";
import React from "react"; // { useEffect, useRef, useState }
import { connect, ConnectedProps } from "react-redux";
import { Card, CardBody, Col, Row } from "reactstrap";
import { AnyAction, Dispatch } from "redux";
import { IPasswordResetRequest } from "@api/schema";
import BaseLayout from "@components/BaseLayout";
import PageError from "@components/common/PageError";
import TranslatedHtml from "@components/common/TranslatedHtml";
import ForgotPasswordForm from "@components/user/ForgotPasswordForm";
import { addNotificationAction } from "@redux/actions/notifications";
import { IFormikActions } from "@redux/helper/actions";
import { AppState } from "@redux/reducer";
import { selectIsAuthenticated } from "@redux/reducer/auth";
import { forgotPasswordAction, selectForgotPasswordUsecaseState } from "@redux/usecases/userAccount";
import { Routes } from "@services/routes";
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    addNotification: (msg: string) => dispatch(addNotificationAction(msg)),
    forgotPassword: (values: IPasswordResetRequest, actions: IFormikActions) => dispatch(forgotPasswordAction(values, actions)),
});
const mapStateToProps = (state: AppState) => ({
    isAuthenticated: selectIsAuthenticated(state),
    forgotPasswordState: selectForgotPasswordUsecaseState(state),
});
const connector = connect(mapStateToProps, mapDispatchToProps);
type PageProps = ConnectedProps<typeof connector>;
const ForgotPasswordPage: React.FC<PageProps> = (props: PageProps) => {
    const { addNotification, forgotPassword, isAuthenticated, forgotPasswordState } = props;
    const { t } = useTranslation("common");
    if (isAuthenticated) {
        void Router.push(Routes.UserProfile);
        return null;
    }
    const onSubmit = (values: IPasswordResetRequest, actions: IFormikActions): void => {
        actions.onSuccess = () => {
            addNotification('message.user.passwordResetRequested');
            void Router.push(Routes.Login);
        };
        forgotPassword(values, actions);
    };
    return <BaseLayout pageTitle={t("page.user.forgotPassword.title")}>
    <Row>
      <Col sm={8}>
        <Card>
          <CardBody>
            <p><TranslatedHtml content="page.user.forgotPassword.intro"/></p>
            <PageError error={forgotPasswordState?.loadingError}/>
            <ForgotPasswordForm onSubmit={onSubmit}/>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </BaseLayout>;
};
const __Next_Translate__Page__18c4f5179d3__ = connector(ForgotPasswordPage);

    export default __appWithI18n(__Next_Translate__Page__18c4f5179d3__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  